import { render, staticRenderFns } from "./goodsDetails.vue?vue&type=template&id=38ebd1e2&scoped=true"
import script from "./goodsDetails.vue?vue&type=script&lang=js"
export * from "./goodsDetails.vue?vue&type=script&lang=js"
import style0 from "./goodsDetails.vue?vue&type=style&index=0&id=38ebd1e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ebd1e2",
  null
  
)

export default component.exports